/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";
import Actions from "../../../../../fluid/Actions/ActionFactory";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { CloudDownload} from '@material-ui/icons'

import {
  Dialog,
  Paper,
  Tooltip,
  Typography,
  IconButton,
  Card,
  CardActionArea,
  CardMedia,
} from "@material-ui/core";

import { Fullscreen, FullscreenExit } from "@material-ui/icons";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc014e",
    },
  },
});

const styles = (theme) => ({
  carouselContainer: {
    //position: "relative",
    maxWidth: "100%",
    maxHeight: "100%",

    "&.carousel": {
      "&.slide": {
        img: {
          height: "80%",
          width: "100%",
        },
      },
    },
  },
});

class ImageViewer extends Component {
  state = {
    openImage: false,
    width: this.props.width,
    download: false,
    image_string : null
  };

  componentWillMount() {
    let downloadUrl = this.props.drl_url + "/" + this.props.drl_result.file_link
    Actions('http_request', {
      url : downloadUrl,
      method : 'get',
      responseType : 'arraybuffer'
    }).then(response => {
        console.log("Download Response : ", response)
        let image_string = Buffer.from(response.data, 'binary').toString('base64')
        console.log("Image Viewer -- Base64 : ", this.state.image_string)
        this.setState({...this.state, image_string : image_string})
        // const url = window.URL.createObjectURL(new Blob([response.data]));
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download', this.getFileName()); //or any other extension
        // document.body.appendChild(link);
        // link.click();
    }).catch(err => {

    })
    console.log("this props image viewer")
    console.log(this.props)
  }

  componentDidMount(){
    let download = false;
    let { params } = this.props;
    if(params.find((element) => element.key === 'download') ) {
        download  = params.find((element) => element.key === 'download').value.boolean;
    }
    this.setState({
      download: download
    })
  }

  expandImage = () => {
    this.setState({ openImage: true });
  };

  switchFullScreen = () => {
    this.setState({ openImage: !this.state.openImage });
  };

  getFileName = () => {
    try {
      let file_name = this.props.record.source_link.src_file_name;
      // let file_array = this.props.record.source_link.path.split("/");
      // file_name = file_array[file_array.length - 1];
      return file_name;
    } catch (err) {
      return "";
    }
  };


  downloadFile = () => {
    let downloadUrl = this.props.drl_url + "/" + this.props.drl_result.src_file_link
    Actions('http_request', {
        url : downloadUrl,
        method : 'get',
        responseType : 'blob'
    }).then(response => {
        console.log("Download Response : ", response)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.getFileName()); //or any other extension
        document.body.appendChild(link);
        link.click();
    }).catch(err => {

    })
   
  }

  renderToolBar = () => {
    let file_name = this.getFileName();
    let downloadUrl= this.props.drl_url + "/" + this.props.drl_result.src_file_link;
    return (
      <Paper
        style={{
          width: this.state.openImage ? "100%" : this.state.width,
          height: "50px",
          backgroundColor: "#FFFFFF",
          padding: "5px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
        square
        elevation={4}
      >
        {" "}
        <Tooltip title={file_name}>
          <Typography
            style={{
              width: "20%",
              flexGrow: 1,
            }}
            variant="overline"
            noWrap={true}
          >
            {file_name}
          </Typography>
        </Tooltip>
        <div
          style={{
            flexGrow: 1,
            display: "flex",
            marginLeft: "5px",
            marginRight: "10px",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        ></div>
        <div style={{ marginLeft: "15px", marginRight: "10px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginLeft: "15px",
            }}
          > 
            {
              this.state.download === true && (

              // <a href={downloadUrl} download={file_name} target="_blank">
                <IconButton 
                  size = 'small'
                  onClick={ (event) => { event.preventDefault(); this.downloadFile()} }
                  // href = {this.props.downloadUrl}
                  // target="_blank"
                  // download = {this.props.filename}
                >
                  <CloudDownload></CloudDownload>
                </IconButton>
              // </a>
            )
            }
            {this.state.openImage ? (
              <IconButton size="small" onClick={this.switchFullScreen}>
                <FullscreenExit></FullscreenExit>
              </IconButton>
            ) : (
              <IconButton size="small" onClick={this.switchFullScreen}>
                <Fullscreen></Fullscreen>
              </IconButton>
            )}
          </div>
        </div>
      </Paper>
    );
  };

  renderFullScreenImageCarousel = () => {
    const { classes } = this.props;
    let src = this.props.drl_url + "/" + this.props.drl_result.file_link;
    return (
      <div style={{ height: "100%", width: "100%" }}>
        {this.renderToolBar()}
        <Carousel
          autoPlay
          showThumbs={false}
          showIndicators={false}
          showStatus={false}
          style={{
            alignItems: "center",
            width: "100%",
            height: "calc(100vh - 20px)",
          }}
          className={classes.carouselContainer}
        >
          <div
            style={{
              height: "calc(100vh - 50px)",
              width: "100%",
              cursor: "pointer",
            }}
          >
            {this.state.image_string !== null && <img
              alt={`${this.getFileName()} expanded`}
              src={"data:image/jpeg;base64," + this.state.image_string}
              style={{
                height: "calc(100vh - 50px)",
                width: "75%",
                cursor: "pointer",
                objectFit: "contain",
              }}
            />}
            {/* <p className="legend">{this.props.file_name}</p> */}
          </div>
        </Carousel>
      </div>
    );
  };

  renderImageCarousel = () => {
    const { classes } = this.props;
    let src = this.props.drl_url + "/" + this.props.drl_result.file_link;
    let downloadUrl= this.props.drl_url + "/" + this.props.drl_result.src_file_link;
      
    return (
      <Fragment>
        {this.renderToolBar()}
        <Carousel
          showThumbs={false}
          showIndicators={false}
          showStatus={false}
          // style={{
          //   height: this.props.height - 200,
          //   width: "80%",
          //   margin: "10%",
          //   backgroundColor: "#fff"
          // }}

          className={classes.carouselContainer}
        >
          <div
            style={{
              height: this.props.height - 100,
              width: "100%",
              cursor: "pointer",
            }}
            onClick={() => this.expandImage()}
          >
            {this.state.image_string !== null && <img
              alt={`${this.getFileName()}`}
              src={"data:image/jpeg;base64," + this.state.image_string}
              style={{
                height: "100%",
                width: "90%",
                objectFit: "contain",
              }}
            />}
            {/* <p className="legend">{this.props.file_name}</p> */}
          </div>
        </Carousel>
      </Fragment>
    );
  };

  render() {
    console.log("image viewer props");
    console.log(this.props);
    return (
      <div>
        <div
          style={{
            height: this.props.height,
            width: this.props.width,
          }}
          id="image-viewer-container"
        >
          {this.renderImageCarousel()}
        </div>
        <Dialog fullScreen open={this.state.openImage}>
          <div style={{ width: "100%", height: "100%" }}>
            {this.renderFullScreenImageCarousel()}
          </div>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(ImageViewer);
